import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function TopBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="fixed top-0 left-0 w-full bg-red-600 text-white z-50 py-2 px-4 shadow-md" data-id="element-274">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-sm sm:text-base font-medium" data-id="element-275">
        <span className="uppercase tracking-wide font-bold animate-pulse" data-id="element-276">
          ¡Esta oferta termina pronto!
        </span>
        <div className="flex items-center bg-black/20 px-3 py-1 rounded-md font-mono font-bold" data-id="element-277">
          <span data-id="element-278">
            {hours}:{minutes}:{seconds}
          </span>
        </div>
      </div>
    </div>;
}